// @flow
import React from 'react';
import ResetTemplate from 'components/reset/ResetTemplate';
import ResetFormContainer from 'containers/reset/ResetFormContainer';

const Reset = () => {
  return <ResetTemplate form={<ResetFormContainer />} />;
};

export default Reset;



// WEBPACK FOOTER //
// ./src/pages/Reset.js